import styles from './index.module.scss'
import Utils from '@utils/utils'
import { useMemo, useEffect, useState } from 'react'

const SmartDetailPagePreview = ({ tasks = [], className = '', isGenerating = false, onPreviewLongImage }) => {
    const imageList = useMemo(() => {
        return tasks
            .map(item => item?.results?.[0]?.hdImage || item?.results?.[0]?.image)
            .map((url) => Utils.getImgThumbnail(url))
            .filter(Boolean)
    }, [tasks])
    const hasPreviewImages = imageList.length > 0
    const showGeneratingState = isGenerating && !hasPreviewImages
    const imageListKey = useMemo(() => imageList.join('|'), [imageList])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        let active = true
        if (!imageList.length) {
            setLoaded(true)
            return
        }

        setLoaded(false)
        let loadedCount = 0
        const handleLoaded = () => {
            loadedCount += 1
            if (active && loadedCount >= imageList.length) {
                setLoaded(true)
            }
        }

        imageList.forEach((src) => {
            const img = new Image()
            img.onload = handleLoaded
            img.onerror = handleLoaded
            img.src = src
        })

        return () => {
            active = false
        }
    }, [imageListKey])

    return (
        <div
            className={`${styles.SmartDetailPagePreview} ${showGeneratingState ? styles.SmartDetailPagePreviewGenerating : ''} ${className}`.trim()}
            onClick={() => onPreviewLongImage?.()}
        >
            {!showGeneratingState && <div className={styles.Title}>详情页预览</div>}
            {showGeneratingState ? (
                <div className={styles.GeneratingText}>
                    <span>详情页生成中</span>
                    <span>请稍后</span>
                </div>
            ) : !loaded ? <div className={styles.Loading}>加载中...</div> : (
                <div className={styles.LongImage}>
                    {imageList.map((img, index) => (
                        <img
                            key={`${img}_${index}`}
                            className={styles.PreviewImage}
                            src={img}
                            alt={`preview_${index + 1}`}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export default SmartDetailPagePreview
